import React from 'react'
import PropTypes from 'prop-types'

import { Card, List } from 'semantic-ui-react'

import Permissions from 'Components/Permissions'
import PictureCardPictureTypesDownload from 'Components/PictureCard/PictureCardPictureTypesDownload'

import { PICTURE_TYPES } from 'Global/constants'

const PictureCardPictureTypes = ({ picture }) => {
  return (
    <Permissions
      permissions={[
        'picture.action.downloadCropped',
        'picture.action.downloadDesigner',
        'picture.action.downloadEmail',
        'picture.action.downloadOriginal',
        'picture.action.downloadOriginalRaw',
        'picture.action.downloadThumbnail',
      ]}
      render={() => (
        <Card.Content extra>
          <List>
            <Permissions
              permissions="picture.action.downloadEmail"
              render={() => <PictureCardPictureTypesDownload picture={picture} type={PICTURE_TYPES.C3_BIG} />}
            />

            <Permissions
              permissions="picture.action.downloadThumbnail"
              render={() => <PictureCardPictureTypesDownload picture={picture} type={PICTURE_TYPES.C3_THUMBNAIL} />}
            />

            <Permissions
              permissions="picture.action.downloadCropped"
              render={() => <PictureCardPictureTypesDownload picture={picture} type={PICTURE_TYPES.ORIGINAL_CROPPED} />}
            />

            <Permissions
              permissions="picture.action.downloadDesigner"
              render={() => <PictureCardPictureTypesDownload picture={picture} type={PICTURE_TYPES.TIF_DESIGNER} />}
            />

            <Permissions
              permissions="picture.action.downloadOriginal"
              render={() => <PictureCardPictureTypesDownload picture={picture} type={PICTURE_TYPES.ORIGINAL_JPG} />}
            />

            <Permissions
              permissions="picture.action.downloadOriginalRaw"
              render={() => <PictureCardPictureTypesDownload picture={picture} type={PICTURE_TYPES.ORIGINAL_RAW} />}
            />
          </List>
        </Card.Content>
      )}
    />
  )
}

PictureCardPictureTypes.propTypes = {
  picture: PropTypes.object.isRequired,
}

export default PictureCardPictureTypes
